import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import { Typography, Box } from "@mui/material";
import { useSiteState } from "../hookState/SiteState";
import APIURLConstants from "../config/config";
import ApiHelper from "../utillity/ApiHelper";
import Helper from "../utillity/helper";
import { usePlanState } from "../hookState/PlanState";
import { setSocialLoginState } from "../hookState/SocialLoginState";
import { setCartState } from "../hookState/CartState";
import { premiumCount } from "../constants/Constant";
import ProductCard from "./Product/ProductCard";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../constants/RouteConstant";

export default function ServiceProductCard() {
	const navigate = useNavigate();
	const state = useSiteState();
	const [products, setProducts] = useState([]);

	const [loading, setLoading] = useState(false);
	const [redirectPayment, setRedirectPayment] = React.useState(false);
	const [categoryId] = useState("all");

	const planState = usePlanState();
	const [cartCount, setCartCount] = useState(0);
	const [token, setToken] = useState("");
	const [perPage] = useState(1);
	const [currentPage] = useState(1);
	let [cart, setCart] = useState([]);
	const [snackBarProps, setSnackBarProps] = React.useState({
		openSnack: false,
		variant: "error",
		message: "",
	});
	const [cartAdded, setCartAdded] = useState([]);

	const loginOptionName = Helper.getStorage("loginOption");
	if (loginOptionName) {
		setSocialLoginState(loginOptionName);
	}

	const handlePayment = (price) => {
		navigate(RouteConstants.PAYMENT_GATEWAY, {
			state: { amount: price, type: "unlimited", cart: [] },
		});
		return;
	};
	const getProducts = () => {
		if (state.user.get()) {
			getData(state.user.id.get());
		} else {
			const cart = Helper.getStorage("cart");
			let cartAsin = [];
			if (cart) {
				let cartCopy = [...cart];
				cartAsin = cartCopy.map((key) => key.asin);
			}
			setLoading(true);
			const data = {
				per_page: perPage,
				current_page: currentPage,
				category_id: categoryId,
				user_id: 0,
				cartAsin: cartAsin,
			};
			ApiHelper.post(APIURLConstants.get_products, data)
				.then((res) => {
					setLoading(false);
					setProducts(res.data.result.products);
				})
				.catch((error) => {
					setLoading(false);
				});
		}
	};
	const getData = (id) => {
		setLoading(true);
		const data = {
			per_page: perPage,
			current_page: currentPage,
			category_id: categoryId,
			user_id: id,
		};
		ApiHelper.post(APIURLConstants.get_products, data)
			.then((res) => {
				setLoading(false);

				setProducts(res.data.result.products);
			})
			.catch((error) => {
				setLoading(false);
			});
	};
	const addCartItem = (productInfo) => {
		const dataLayerCart = Helper.getStorage("dataLayerCart");
		console.log(dataLayerCart);

		if (
			state.plan.get() !== null &&
			state.plan !== "" &&
			state.plan !== undefined
		) {
			if (cartCount >= premiumCount) {
				setSnackBarProps({
					openSnack: true,
					variant: "error",
					message: "Please contact to contact@ecominsider.net",
				});
				return;
			}

			// Helper.setStorage("dataLayerCart", productInfo);

			ApiHelper.post(APIURLConstants.add_products_myaccount, productInfo)
				.then((res) => {
					console.log(res);
					if (res.data) {
						if (res.data.success) {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Added in MyAccount",
							});

							if (dataLayerCart === null) {
								let dataLayerCartCopy = [];
								Helper.setStorage("dataLayerCart", productInfo);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: productInfo,
									},
								});
							} else {
								console.log("dataLayerCart", dataLayerCart);
								let dataLayerCartCopy = [dataLayerCart];

								dataLayerCartCopy.push(productInfo);
								Helper.setStorage("dataLayerCart", dataLayerCartCopy);

								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: dataLayerCartCopy,
									},
								});
							}
							getProducts();
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			ApiHelper.post(APIURLConstants.ADD_TO_CART, productInfo)
				.then((res) => {
					console.log(res);
					if (res.data) {
						if (res.data.success) {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Added in Card",
							});
							getProducts();
							getCart(productInfo.user_id);

							if (dataLayerCart === null) {
								Helper.setStorage("dataLayerCart", productInfo);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: productInfo,
									},
								});
							} else {
								let dataLayerCartCopy = [dataLayerCart];
								dataLayerCartCopy.push(productInfo);
								Helper.setStorage("dataLayerCart", dataLayerCartCopy);
								window.dataLayer.push({
									event: "add_to_cart",
									ecommerce: {
										currency: "",
										value: "",
										items: dataLayerCartCopy,
									},
								});
							}
						} else {
							setSnackBarProps({
								openSnack: true,
								variant: "success",
								message: "Product Already in Cart",
							});
							return;
						}
					}
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};
	const addItem = (item) => {
		const cart = Helper.getStorage("cart");
		if (cart) {
			let cartCopy = [...cart];
			let { id } = item;
			let existingItem = cartCopy.find((cartItem) => cartItem.id == id);

			if (existingItem) {
				setSnackBarProps({
					openSnack: true,
					variant: "success",
					message: "Product Already in Cart",
				});
				return;
			} else {
				cartCopy.push(item);
			}
			setCart(cartCopy);
			setCartState(cartCopy);
			Helper.setStorage("cart", cartCopy);
			setSnackBarProps({
				openSnack: true,
				variant: "success",
				message: "Product Added in Card",
			});
			window.dataLayer.push({
				event: "add_to_cart",
				ecommerce: {
					currency: "",
					value: "",
					items: cartCopy,
				},
			});
		} else {
			let cart = [];
			let cartCopy = [...cart];
			let { id } = item;
			let existingItem = cartCopy.find((cartItem) => cartItem.id == id);

			if (existingItem) {
				setSnackBarProps({
					openSnack: true,
					variant: "success",
					message: "Product Already in Cart",
				});
				return;
			} else {
				cartCopy.push(item);
			}
			setCart(cartCopy);
			setCartState(cartCopy);
			Helper.setStorage("cart", cartCopy);
			setSnackBarProps({
				openSnack: true,
				variant: "success",
				message: "Product Added in Card",
			});
			window.dataLayer.push({
				event: "add_to_cart",
				ecommerce: {
					currency: "",
					value: "",
					items: cartCopy,
				},
			});
		}
		getProducts();
	};
	const getCart = (id) => {
		let data = { user_id: id };
		ApiHelper.post(APIURLConstants.GET_CART, data)
			.then((res) => {
				// setCartCount(res.data.result.products.length);
				setCartState(res.data.result.products);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	useEffect(() => {
		getProducts();
	}, [perPage, currentPage]);
	return (
		<Card
			sx={{
				width: { xs: 290, md: 600 },
				height: { xs: 430, md: 400 },
				gap: { xs: 0, md: 2 },
				borderRadius: 8,
				p: { xs: 0, md: 2 },
				// py: { xs: 5, md: 2 },
				// px: { xs: 2, md: 2 },

				bgcolor: "#FFF5E5",
			}}
		>
			<CardContent>
				<Typography
					gutterBottom
					fontWeight={600}
					fontSize={{ xs: 22, md: 32 }}
					px={{ xs: 2, md: 0 }}
				>
					{"Market Analysis"}
				</Typography>
				<Typography
					fontWeight={400}
					fontSize={{ xs: 16, md: 18 }}
					sx={{ color: "#667085" }}
					px={{ xs: 2, md: 0 }}
				>
					It is vital that you sell the right product at the right price.
					Remember! You have to sell what the market is looking for and what the
					market wants to buy. With 1 click you can access market data on
					winning products!
				</Typography>
			</CardContent>

			<Box>
				{products.map((product, index) => {
					return index === 0 ? (
						<ProductCard
							key={index}
							data={product}
							myAccount={false}
							addItem={addItem}
							addCartItem={addCartItem}
							width={500}
							// checkProductExist={checkProductExist}
						/>
					) : null;
				})}
			</Box>
		</Card>
	);
}
